module.exports = __webpack_public_path__ + "assets/b115.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b115.png
// module id = 587
// module chunks = 0